module.exports = __webpack_public_path__ + "img/search.e052de57.svg";